import SortableTable, {ColumnConfig} from '../SortableTable'
import {makeStyles} from '@mui/styles'
import {primaryButton, secondaryButton} from '../../assets/styles/buttons'
import {rxrGreenColor} from '../../assets/styles/color'
import React, {useCallback, useMemo} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import DashboardToggle from './../DashboardToggle'
import ActionMenu from './ActionMenu'
import {setAmenityIsVisible} from '../../actions/amenitiesActions'
import {ONBOARDING_AMENITY_KEY_PICKUP_LABEL, AMENITY_TYPE_OPERATIONAL, AMENITY_TYPE_RECREATIONAL} from '../../constants/ModelConstants'

const useStyles = makeStyles(() => ({
  checkInButton: {
    ...primaryButton,
  },
  checkInButtonConfirm: {
    ...secondaryButton,
    borderColor: rxrGreenColor,
    color: rxrGreenColor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  menuIcon: {
    paddingLeft: 15,
  },
}))

const NULL_MUTATE = value => (value ? value.toLowerCase() : '0')

const getAmenityType = (isOnboardingOnly, label) => {
  if (isOnboardingOnly && label === ONBOARDING_AMENITY_KEY_PICKUP_LABEL) return 'Key pick-up'
  else if (isOnboardingOnly) return 'Elevator'
}

const AmenityManagerTable = function ({amenityType}) {
  const classes = useStyles()
  const dispatch = useDispatch()

  const amenitiesLookup = useSelector(state => state.Amenities.amenitiesLookup)

  const handleToggle = useCallback((isSelected, amenityId) => {
    setAmenityIsVisible(dispatch, amenityId, isSelected).catch(err => {
      window.alert(err.message)
    })
  }, [dispatch])

  const amenitiesToShow = useMemo(() => {
    let amenities = Object.values(amenitiesLookup)
    if (amenityType === AMENITY_TYPE_RECREATIONAL) {
      amenities = amenities.filter(a => !a.isOnboardingOnly)
    } else if (amenityType === AMENITY_TYPE_OPERATIONAL) {
      amenities = amenities.filter(a => a.isOnboardingOnly)
    }
    return amenities
  }, [amenitiesLookup, amenityType])

  const columns = useMemo(() => [
    new ColumnConfig({
      title: 'Name',
      render: g => g.label,
      comparator: ColumnConfig.simpleComparatorGenerator('label'),
      isDefaultSort: true,
    }),

    amenityType === AMENITY_TYPE_OPERATIONAL
      ? new ColumnConfig({
          title: 'Type',
          render: g => getAmenityType(g.isOnboardingOnly, g.label),
          comparator: (a, b) => getAmenityType(a.isOnboardingOnly, a.label).localeCompare(getAmenityType(b.isOnboardingOnly, b.label)),
        })
      : null,

    new ColumnConfig({
      title: 'Active',
      render: a => <DashboardToggle value={a.isVisible} onChange={isSelected => handleToggle(isSelected, a.id)} />,
      comparator: (a, b) => b.isVisible - a.isVisible,
    }),

    new ColumnConfig({
      title: 'Availability',
      render: g => (g.needsApproval ? 'Needs approval' : "Doesn't need approval"),
      comparator: ColumnConfig.simpleComparatorGenerator('needsApproval', undefined, NULL_MUTATE),
    }),

    new ColumnConfig({
      title: 'Actions',
      render: a => (
        <div className={classes.menuIcon}>
          <ActionMenu amenity={a} />
        </div>
      ),
    }),
  ].filter(c => !!c), [amenityType, classes, handleToggle])

  return <SortableTable data={amenitiesToShow} columns={columns} />
}

export default AmenityManagerTable
